// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Reload = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="m49.26 20.059 9.217-8.053a2 2 0 1 0-2.631-3.012L42.527 20.63a2.002 2.002 0 0 0-.094 2.926L55.752 36.78a1.996 1.996 0 0 0 2.828-.011 1.999 1.999 0 0 0-.009-2.828l-9.971-9.9c16.12.323 29.137 13.527 29.137 29.722C77.737 70.16 64.397 83.5 48 83.5S18.263 70.16 18.263 53.763a2 2 0 0 0-4 0C14.263 72.366 29.397 87.5 48 87.5s33.737-15.134 33.737-33.737c0-18.18-14.456-33.038-32.477-33.704"
			fillRule="evenodd"
		/>
	</svg>
);
export default Reload;
